import { ECityType } from 'shared/repositories/commercial-search-offers/entities/underground_dto_for_offer_snippet/UndergroundDtoForOfferSnippetSchema';
import { TransportTypes } from 'shared/types/TransportTypes';

export function mapCityTypeToTransportType(cityType: ECityType): TransportTypes {
  switch (cityType) {
    case ECityType.Ekb:
      return 'ekb';
    case ECityType.Kazan:
      return 'kzn';
    case ECityType.Msk:
      return 'mow';
    case ECityType.Nizhniy:
      return 'nn';
    case ECityType.Novosib:
      return 'nsk';
    case ECityType.Samara:
      return 'smr';
    case ECityType.Spb:
      return 'spb';
  }
}
